<div class="head">
  <img src="/assets/images/logo_elliance.png" class="logo" height="30">
</div>